import {getLawyerStatus} from '@/http/modules/lawcase'

const state = {
    lawyerStatus: ''
}
const mutations = {
    setLawyerStatus(state, status) {
        state.lawyerStatus = status
    },
}
const actions = {
    getLawyerStatus({commit}) {
        getLawyerStatus().then(res => {
            if (res) {
                commit('setLawyerStatus', res.status)
            }
        })
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
